<vwui-modal-header>
    <h2 a11yPageTitleLevel="2">{{ 'PROJECT_VERSIONS_LIST.modal.title' | translate }}</h2>
</vwui-modal-header>

<vwui-modal-body>
    @if (isLoading()) {
        <vwui-spinner></vwui-spinner>
    } @else if (versions().length === 0) {
        <p class="empty-state">{{ 'PROJECT_VERSIONS_LIST.modal.empty' | translate }}</p>
    } @else {
        <table class="versions-table">
            <thead>
                <tr>
                    <th>{{ 'PROJECT_VERSIONS_LIST.table.version' | translate }}</th>
                    <th>{{ 'PROJECT_VERSIONS_LIST.table.createdAt' | translate }}</th>
                    <th>{{ 'PROJECT_VERSIONS_LIST.table.createdBy' | translate }}</th>
                    <th>{{ 'PROJECT_VERSIONS_LIST.table.note' | translate }}</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                @for (version of versions(); track trackVersion($index, version)) {
                    <tr>
                        <td>{{ version.majorVersion }}.{{ version.minorVersion }}</td>
                        <td>{{ version.date }} om {{ version.time }}</td>
                        <td>{{ version.createdBy }}</td>
                        <td>
                            @if (version.note) {
                                {{ version.note }}
                            } @else {
                                <span class="placeholder">{{ 'PROJECT_VERSIONS_LIST.modal.note_placeholder' | translate }}</span>
                            }
                        </td>
                        <td class="actions">
                            @if (version.attachment) {
                                <vwui-button (click)="download(version)" class="is-secondary">
                                    {{ 'PROJECT_VERSIONS_LIST.button.download' | translate }}
                                </vwui-button>
                            } @else {
                                {{ noAttachmentReason(version) | translate }}
                            }
                        </td>
                    </tr>
                }
            </tbody>
        </table>
    }
</vwui-modal-body>

<vwui-modal-footer>
    <vwui-button (click)="modalRef.close(null)" class="is-secondary">
        {{ 'BUTTON.close' | translate }}
    </vwui-button>
</vwui-modal-footer>
